import { Spacing } from "@p0security/ui";
import { Prefix } from "components/GraphTable/Prefix";
import { SearchInput } from "components/antd";
import { useCallback } from "react";

export const RequestSearch: React.FC<{
  onInputChange: (value: string | null) => void;
  searchQuery: string | null;
}> = ({ onInputChange, searchQuery }) => {
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      onInputChange(value === "" ? null : value);
    },
    [onInputChange]
  );
  return (
    <Prefix prefix="Search" className="w-full">
      <Spacing asChild mb="unset">
        <SearchInput
          value={searchQuery ?? ""}
          onChange={onChange}
          placeholder={"Enter search terms..."}
          /* eslint-disable-line react/forbid-component-props */ style={{
            flexGrow: 1,
          }}
        />
      </Spacing>
    </Prefix>
  );
};
